import React, { useState } from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useQueries } from "@tanstack/react-query";
import { getConfigSports, getEventUnits, getEvents, getScheduleData } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import SessionScheduleTable from "components/common/schedule/SessionScheduleTable";
import Label from "components/general/Label";
import { SELECTOR_DISPLAY_TYPE, TYPE_DATA, dateFormat, getDateTimeFormat, groupByDate, groupByDateNoTz, isParalympic, sortDataByField } from "helpers/utils";
import { Accordion } from "react-bootstrap";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import DateScheduleTable from "components/common/schedule/DateScheduleTable";
import useViewport from "components/general/useViewPort";
import SelectorDay from "components/common/selector-day/SelectorDay";
import DayList from 'components/common/selector-day/Day';
import { useSelector } from "react-redux";
import { useAbsoluteRoot } from "helpers/urlRoot";
import { useGetDisciplines } from "helpers/commonCodes";

//Sport Pictos Sprites SpritePictosSmall for the old ones and SpritePictosBig for the new big ones (Paris2024) 

//import SpritesPictos from "styles/OG2024/images/SpritePictosSmall.svg";
import SpritesPictos from "styles/OG2024/images/SpritePictosBig.svg";
//import SpritesPictos_Para from "styles/PG2024/images/SpritePictosSmall.svg";
import SpritesPictos_Para from "styles/PG2024/images/SpritePictosBig.svg";
import DateTime, { DateTimeNoTimezone } from "components/presentation/DateTime";
import SelectorTimeZone from "components/common/selectors/selector-timezone";

const ScheduleDate = ({ scheduleGridData }) => {

  const { mirs_competition, mirs_language, mirs_date, mirs_event } =
    useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();
  const timeZone = useSelector((state) => state.appGlobal.timezone)
  const { urlRoot } = useAbsoluteRoot();
  const disciplines = useGetDisciplines({ mirs_competition, mirs_language });
  // use as object to mutate it
  const [activeDisciplineAccordion, setAtiveDisciplineAccordion] = useState({ current: '' });
  let configArray = [];
  let allCompetitionDays = { competition_schedule: [] };

  ////

  var result = [];
  scheduleGridData?.competition_schedule.forEach(res => {
    if (res?.discipline) {
      let newDate = dateFormat(res.dateTime)
      let dateVenue = dateFormat(res.dateTime, process.env.REACT_APP_TIME_ZONE)

      let sch = result.find(item => item.date === newDate && item.discipline.code === res.discipline.code)
      if (!sch) {
        let csObject = {
          "discipline": res.discipline,
          "dateVenue": dateVenue,
          "date": newDate,
          "eventCount": 1,
          "medalEventCount": res.medalEventCount > 0 ? 1 : 0,
          "liveEventCount": res.liveEventCount > 0 ? 1 : 0,
          "events": res.medalEventCount > 0 ? [res.event] : []
        }
        result.push(csObject)
      } else {
        sch.eventCount = sch?.eventCount + 1
        sch.medalEventCount = res?.medalEventCount > 0 ? sch?.medalEventCount + 1 : sch?.medalEventCount
        sch.liveEventCount = res?.liveEventCount > 0 ? sch?.liveEventCount + 1 : sch?.eEventCount
        if (sch?.alEventCount > 0 && !sch?.events.find(item => item?.code === res?.event?.code)) {
          sch.events = [...sch?.events, res?.event]
        }
      }
    }
  })

  //////



  // let filteredDisciplines = [];
  let filteredSchduleByDate = [];
  if (result.length > 0) {
    allCompetitionDays.competition_schedule = result || [];
    filteredSchduleByDate = result?.filter(item => item.date === mirs_date);
  }

  let Sprites

  if (isParalympic(mirs_competition)) {
    Sprites = SpritesPictos_Para;
  } else {
    Sprites = SpritesPictos;
  }

  filteredSchduleByDate?.forEach(sch => {
    configArray.push({
      queryKey: ['ConfigSports', mirs_competition, sch?.discipline?.code, urlRoot],
      queryFn: getConfigSports,
      refetchInterval: 0,
      //staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!mirs_competition && !!sch?.discipline?.code
    });
    configArray.push({
      queryKey: ['CC_Events', mirs_competition, sch?.discipline?.code, mirs_language?.toUpperCase()],
      queryFn: getEvents,
      refetchInterval: 0,
    })
    configArray.push({
      queryKey: ['CC_EventUnits', mirs_competition, sch?.discipline?.code, mirs_language?.toUpperCase()],
      queryFn: getEventUnits,
      refetchInterval: 0,
    })
  });


  const sportsConfigs = useQueries({ queries: configArray });
  const isLoadingSportsConfigs = sportsConfigs.some(result => result.isLoading);
  const isErrorSportsConfigs = sportsConfigs.every(result => result.isError);
  const allSuccessSportsConfigs = sportsConfigs.some(result => result.isSuccess === true);

  let queryArray = [];
  if (allSuccessSportsConfigs) {
    filteredSchduleByDate?.forEach((item) => {
      const isH2H = sportsConfigs?.find(spC => {
        return item?.discipline?.code === spC?.data?.code
      })?.data?.isH2H;

      queryArray.push({
        queryKey: ["scheduleDate", mirs_competition, mirs_language, item.discipline.code, item.dateVenue, mirs_event, isH2H],
        queryFn: getScheduleData,
        refetchInterval: 30000,
        enabled: allSuccessSportsConfigs,
        suspense: false,
      })
    })
  }

  const sportsScheduleInAday = useQueries({ queries: queryArray });
  const isLoadingSportsScheduleInAday = sportsScheduleInAday.some(result => result.isLoading);
  const isErrorSportsScheduleInAday = sportsScheduleInAday.some(result => result.isError);
  const allSuccessSportsScheduleInAday = sportsScheduleInAday.every(result => result.isSuccess === true);

  if (isErrorSportsScheduleInAday || isErrorSportsConfigs) { return <NotAvailable />; }
  if (isLoadingSportsConfigs || isLoadingSportsScheduleInAday) { return <Loader /> }
  if (allSuccessSportsScheduleInAday || allSuccessSportsConfigs) {

    sportsScheduleInAday.sort((a, b) => {
      const aDesc = disciplines?.disciplines?.find(d => d?.code === a.data[0]?.discipline?.code)?.description;
      const bDesc = disciplines?.disciplines?.find(d => d?.code === b.data[0]?.discipline?.code)?.description;
      return aDesc?.localeCompare(bDesc)
    });

    let items = new Map();
    sportsScheduleInAday && sportsScheduleInAday.forEach((item, index) => {
      const data = item?.data?.filter((u) => u?.eventUnit?.phase?.type?.match('[13]'));
      if (data?.length && !items.has([data[0].discipline.code])) {
        items.set(data[0].discipline.code, data);
      }
    });

    let itemsDates = { competition_schedule: [] };
    let date = dateFormat(mirs_date, undefined, "DD MMM");
    let dates = groupByDateNoTz(allCompetitionDays.competition_schedule, 'date');

    for (const key in dates) {
      itemsDates.competition_schedule.push({ date: key })
    }
    sortDataByField(itemsDates.competition_schedule, 'date', true, TYPE_DATA.DATE)

    function DisciplineSelector() {
      // scroll to discipline
      const handleSelectDiscipline = (discipline) => {
        setAtiveDisciplineAccordion({ current: discipline });
      }

      return (
        <div className="mb-5">
          <div className="fw-bold p-3 bg-dark text-white">
            <Label data={'LabelCompetitionsOf'} />
            <span className="text-nowrap">
              &nbsp;<DateTimeNoTimezone format={getDateTimeFormat('DateLong')} datetime={mirs_date} />
            </span>
          </div>
          <div className="d-flex gap-2 p-2 flex-wrap flex-row schedule-title-all-sports border border-3 border-top-0 border-dark">
            {Array.from(items.entries()).map((entry, index) => {
              const [discipline,] = entry;
              const disciplineDesc = disciplines?.disciplines?.find((item) => item.code === discipline)?.description;
              return <>
                <div style={{ cursor: "pointer" }} onClick={() => handleSelectDiscipline(discipline)} className="discipline-sport " >
                  <svg role="img" className='sport-icon' aria-hidden="true" focusable="false"> <title>{disciplineDesc}</title><use xlinkHref={`${Sprites}#${discipline}`} /></svg>
                </div>
                {/* <div style={{ cursor: "pointer" }} onClick={() => handleSelecºtDiscipline(discipline)} className={`sport-icon ${discipline}`} alt={disciplineDesc}></div>*/}
              </>
            })}
          </div>
        </div>
      )
    }


    let isBreaked = breakPoint === "md" || breakPoint === "sm" || breakPoint === "xs";
    return (
      <>
        <nav className='selectors-container' direction={isBreaked ? "horizontal" : "vertical"} aria-labelledby="NavScheduleDate">
          <span id="NavScheduleDate" className="d-none"><Label data={'LabelScheduleDateNav'} /></span>
          {
            (isBreaked)
              ? <>
                <SelectorTimeZone />
                <div className="d-flex">
                  <SelectorDay daysItems={itemsDates} page="schedule" />
                </div>
              </>
              : <>
                <DayList daysItems={itemsDates} page="schedule" />
                <div className="d-flex justify-content-end">
                  <SelectorTimeZone />
                </div>
              </>
          }
          <div className="d-flex">
            <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="schedule" disciplinesList={Array.from(items.entries()).map(entry => entry[0])} useDisciplinesList={true} />
          </div>
        </nav>
        <DisciplineSelector />
        {Array.from(items.entries())?.map((entry, index) => {
          const [discipline, scheduleData] = entry;
          const eventorder = scheduleData[0]?.discipline?.eventorder
          let schedule = null;
          const isH2H = sportsConfigs?.find(spC => {
            return discipline === spC?.data?.code
          })?.data?.isH2H;


          if (scheduleData?.length > 0) {
            switch (eventorder) {
              case 'DATE':
              case 'LOC':
                schedule = <DateScheduleTable data={scheduleData} eventorder={eventorder} key={`schedule-${discipline}-${date}`} activeDiscipline={activeDisciplineAccordion} isH2H={isH2H} />
                break;
              case 'SESSION':
                schedule = <SessionScheduleTable data={scheduleData} key={`schedule-${discipline}-${date}`} activeDiscipline={activeDisciplineAccordion} isH2H={isH2H} />
                break;
              default:
                schedule = <DateScheduleTable data={scheduleData} eventorder={eventorder} key={`schedule-${discipline}-${date}`} activeDiscipline={activeDisciplineAccordion} isH2H={isH2H} />
                break;
            }
          } else {
            schedule = null;
          }
          return schedule;
        })}
      </>
    );
  };
}

export default ScheduleDate;
